const normalize = (value) => String(value || '').trim();

export const updateParagraphMenuActiveState = (editor) => {
  const selectionEl = editor?.selection?.element?.();
  const isCodeView = editor?.codeView?.isActive?.();

  let block = selectionEl;
  while (
    block &&
    !/^(P|DIV|LI|H1|H2|H3|H4|H5|H6|PRE|BLOCKQUOTE)$/.test(block.tagName)
  ) {
    block = block.parentElement;
  }

  if (!block) return;

  const inlineLineHeight = normalize(block.style?.lineHeight);
  const computedLineHeight = normalize(
    window.getComputedStyle(block).lineHeight
  );
  const fontSize = parseFloat(window.getComputedStyle(block).fontSize || '16');

  document
    .querySelectorAll(
      '.teo-insert-menu .teo-insert-item, .teo-format-menu .teo-insert-item'
    )
    .forEach((el) => {
      const key = el.getAttribute('data-active-key');
      const disabledKey = el.getAttribute('data-disabled-key');
      const check = el.querySelector('.teo-active-check');

      el.classList.remove('teo-insert-item_disabled');
      el.removeAttribute('aria-disabled');

      el.classList.remove('teo-insert-item_active');
      check?.classList.add('hidden');

      if (isCodeView && key === 'codeView:html') {
        el.classList.add('teo-insert-item_active');
        check?.classList.remove('hidden');
      }
      if (!block) return;

      if (disabledKey === 'outdent') {
        const marginLeft = parseFloat(
          block.style?.marginLeft ||
            window.getComputedStyle(block).marginLeft ||
            '0'
        );

        const paddingLeft = parseFloat(
          block.style?.paddingLeft ||
            window.getComputedStyle(block).paddingLeft ||
            '0'
        );

        const isListItem = block.tagName === 'LI';
        const listLevel = isListItem
          ? block.closest('ul, ol')?.closest('li')
          : null;

        const canOutdent =
          marginLeft > 0 || paddingLeft > 0 || Boolean(listLevel);

        if (!canOutdent) {
          el.classList.add('teo-insert-item_disabled');
          el.setAttribute('aria-disabled', 'true');
        }
      }

      if (!key) return;
      let active = false;

      if (key.startsWith('paragraphStyle:')) {
        const className = key.replace('paragraphStyle:', '');
        active = block.classList.contains(className);
      }

      if (key.startsWith('lineHeight:')) {
        const value = key.replace('lineHeight:', '');
        const pxValue = `${Number(value) * fontSize}px`;

        active =
          inlineLineHeight === value ||
          inlineLineHeight === `${value}em` ||
          computedLineHeight === value ||
          computedLineHeight === `${value}em` ||
          Math.abs(parseFloat(computedLineHeight) - parseFloat(pxValue)) < 1;
      }

      if (key.startsWith('paragraphFormat:')) {
        const tag = key.replace('paragraphFormat:', '');
        const blockTag = block.tagName;

        if (tag === 'N') {
          active = ![
            'H1',
            'H2',
            'H3',
            'H4',
            'H5',
            'H6',
            'PRE',
            'BLOCKQUOTE',
          ].includes(blockTag);
        } else {
          active = blockTag === tag;
        }
      }
      if (key.startsWith('inlineFormat:')) {
        const format = key.replace('inlineFormat:', '');

        let node = selectionEl;

        while (node && node !== editor.el) {
          const tagName = node.tagName;

          if (format === 'strikeThrough') {
            active =
              tagName === 'S' ||
              tagName === 'STRIKE' ||
              tagName === 'DEL' ||
              window
                .getComputedStyle(node)
                .textDecorationLine.includes('line-through');
          }

          if (format === 'superscript') {
            active =
              tagName === 'SUP' ||
              window.getComputedStyle(node).verticalAlign === 'super';
          }

          if (format === 'subscript') {
            active =
              tagName === 'SUB' ||
              window.getComputedStyle(node).verticalAlign === 'sub';
          }

          if (active) break;

          node = node.parentElement;
        }
      }
      if (key.startsWith('align:')) {
        const align = key.replace('align:', '');

        const textAlign =
          block.style?.textAlign ||
          window.getComputedStyle(block).textAlign ||
          '';

        active =
          (align === 'left' &&
            (!textAlign || textAlign === 'left' || textAlign === 'start')) ||
          (align === 'center' && textAlign === 'center') ||
          (align === 'right' &&
            (textAlign === 'right' || textAlign === 'end')) ||
          (align === 'justify' && textAlign === 'justify');
      }

      if (key.startsWith('list:')) {
        const [, listType, listStyle] = key.split(':');

        const li = selectionEl?.closest?.('li');
        const list = li?.closest?.('ul, ol');

        if (list) {
          const currentListType = list.tagName;
          const currentStyle =
            list.style?.listStyleType ||
            window.getComputedStyle(list).listStyleType ||
            'default';

          active =
            currentListType === listType &&
            (currentStyle === listStyle ||
              (listStyle === 'default' &&
                ['decimal', ''].includes(currentStyle)));
        }
      }

      if (active) {
        el.classList.add('teo-insert-item_active');
        check?.classList.remove('hidden');
      }
    });
};

export const updateParagraphFormatButtonLabel = (editor) => {
  const selectionEl = editor?.selection?.element?.();
  const block =
    selectionEl?.closest?.('p, div, li, h1, h2, h3, h4, h5, h6, pre') ||
    selectionEl;

  if (!block) return;

  const tag = block.tagName;

  const labelMap = {
    P: window.i18n.t('widgets.toolbar_button.body_text'),
    DIV: window.i18n.t('widgets.toolbar_button.body_text'),
    H1: 'Heading 1',
    H2: 'Heading 2',
    H3: 'Heading 3',
    H4: 'Heading 4',
    PRE: 'Code',
  };

  const label =
    labelMap[tag] || window.i18n.t('widgets.toolbar_button.body_text');

  document
    .querySelectorAll(
      '.fr-command[data-cmd="ParagraphFormatMenu"] .teo-format-btn-label'
    )
    .forEach((el) => {
      el.textContent = label;
    });
};

const getAlignIcon = (editor) => {
  const selection = editor.selection.element();
  const block = selection?.closest?.(
    'p,div,h1,h2,h3,h4,h5,h6,li,td,th,blockquote'
  );

  const textAlign =
    block?.style?.textAlign ||
    (block ? window.getComputedStyle(block).textAlign : '') ||
    '';

  if (textAlign === 'center') {
    return '<i class="teo-align-menu-icon far fa-align-center text-[17px]"></i>';
  }

  if (textAlign === 'right' || textAlign === 'end') {
    return '<i class="teo-align-menu-icon far fa-align-right text-[17px]"></i>';
  }

  if (textAlign === 'justify') {
    return '<i class="teo-align-menu-icon far fa-align-justify text-[17px]"></i>';
  }

  return '<i class="teo-align-menu-icon far fa-align-left text-[17px]"></i>';
};

export const updateAlignToolbarIcon = (editor) => {
  const btn = editor.$tb.find('.fr-command[data-cmd="ParagraphAlignMenu"]');
  if (!btn.length) return;

  btn.find('.teo-align-menu-icon').remove();
  btn.prepend(getAlignIcon(editor));
};

export const alignDropdownToLeft = (editor, cmd) => {
  const apply = () => {
    const btn = editor.$tb.find(`.fr-command[data-cmd="${cmd}"]`).get(0);

    const popup = document.querySelector(
      `.fr-dropdown-menu[id^="dropdown-menu-${cmd}"]`
    );

    if (!btn || !popup) return;

    const btnRect = btn.getBoundingClientRect();
    const popupWidth = popup.offsetWidth || popup.getBoundingClientRect().width;

    popup.style.setProperty(
      'transform',
      `translateX(-${popupWidth - btnRect?.width}px)`,
      'important'
    );
  };

  setTimeout(apply, 0);
};

export const keepMoreOptionsMenuActiveInCodeView = (editor) => {
  const isCodeView = editor?.codeView?.isActive?.();

  const btn = editor?.$tb
    ?.find?.('.fr-command[data-cmd="MoreOptionsMenu"]')
    ?.get?.(0);

  if (!btn) return;

  if (isCodeView) {
    btn.classList.remove('fr-disabled');
    btn.removeAttribute('disabled');
    btn.setAttribute('aria-disabled', 'false');
  }
};

let lastTextColor = '#231F20';
let lastBgColor = '#FCCC4A';

const setColorIndicator = (btn, color) => {
  if (!btn || !color) return;

  btn.style.position = 'relative';

  let line = btn.querySelector('.teo-color-line');

  if (!line) {
    line = document.createElement('span');
    line.className = 'teo-color-line';
    btn.appendChild(line);
  }

  line.style.backgroundColor = color;
};

const getSelectionNode = (editor) => {
  const selection = window.getSelection?.();
  const node = selection?.focusNode;

  if (node) {
    return node.nodeType === Node.TEXT_NODE ? node.parentElement : node;
  }

  return editor?.selection?.element?.();
};

const getCurrentTextColor = (editor) => {
  let el = getSelectionNode(editor);

  while (el && el !== editor.el) {
    const color = el.style?.color || window.getComputedStyle(el).color;

    if (color && color !== 'inherit') {
      return color;
    }

    el = el.parentElement;
  }

  return null;
};

const getCurrentBgColor = (editor) => {
  let el = getSelectionNode(editor);

  while (el && el !== editor.el) {
    const bg =
      el.style?.backgroundColor ||
      window.getComputedStyle(el).backgroundColor ||
      '';

    if (bg && bg !== 'transparent' && bg !== 'rgba(0, 0, 0, 0)') {
      return bg;
    }

    el = el.parentElement;
  }

  return null;
};

export const updateColorToolbarButtons = (editor, colors = {}) => {
  const currentTextColor = getCurrentTextColor(editor);
  const currentBgColor = getCurrentBgColor(editor);

  if (colors.textColor) lastTextColor = colors.textColor;
  else if (currentTextColor) lastTextColor = currentTextColor;

  if (colors.backgroundColor) lastBgColor = colors.backgroundColor;
  else if (currentBgColor) lastBgColor = currentBgColor;

  const textBtn = editor?.$tb
    ?.find?.('.fr-command[data-cmd="textColor"]')
    ?.get?.(0);

  const bgBtn = editor?.$tb
    ?.find?.('.fr-command[data-cmd="backgroundColor"]')
    ?.get?.(0);

  setColorIndicator(textBtn, lastTextColor);
  setColorIndicator(bgBtn, lastBgColor);
};

export const updateColorToolbarButtonsDelayed = (editor, colors = {}) => {
  setTimeout(() => updateColorToolbarButtons(editor, colors), 0);
  setTimeout(() => updateColorToolbarButtons(editor, colors), 50);
  setTimeout(() => updateColorToolbarButtons(editor, colors), 150);
  setTimeout(() => updateColorToolbarButtons(editor, colors), 300);
};

export const centerFroalaPopupUnderToolbar = (editor, popupName) => {
  const popup = editor.popups.get(popupName)?.get?.(0);
  const toolbar = editor.$tb?.get?.(0);
  const box = editor.$box?.get?.(0);

  if (!popup || !toolbar || !box) return;

  const boxRect = box.getBoundingClientRect();
  const toolbarRect = toolbar.getBoundingClientRect();
  const popupRect = popup.getBoundingClientRect();

  const left = boxRect.left + boxRect.width / 2 - popupRect.width / 2;
  const top = toolbarRect.bottom + 8;

  popup.style.setProperty('position', 'fixed', 'important');
  popup.style.setProperty('left', `${Math.max(left, 8)}px`, 'important');
  popup.style.setProperty('top', `${top}px`, 'important');
  popup.style.setProperty('transform', 'none', 'important');
};
